<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 60px; top: 116px">
      <p>
        Para realizar esta actividad vuelve a leer el poema "El sapito Glo Glo
        Glo".
      </p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 60px; top: 165px">
      <p>Completa el resumen.</p>
    </span>

    <p id="tag01" class="textBase basicItem01 tagDefault">SE ESCONDE.</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">GLO GLO GLO.</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">ESCUCHAR.</p>
    <p id="tag04" class="textBase basicItem01 tagDefault">CUANDO LLUEVE</p>
    <p id="tag05" class="textBase basicItem01 tagDefault">SAPITO.</p>

    <h2 id="text01" class="textBase">
      CUANDO COMIENCE A LLOVER NO DEJES DE BUSCAR AL SAPITO
    </h2>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputField01"
      class="pageElement"
    />

    <div
      class="pageElement text-box-a hover-animation-a"
      id="globe"
      style="background-image: url(/pages/img/sordoglo/svgGlo22globe.svg)"
    >
      <p class="textBase" id="textBox01Text">Ahora lee el texto.</p>
    </div>
    <!--- FOOTER --->
    <span class="footer-page footer-read"></span>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 59px;
  top: 112px;
}
#globe {
  position: absolute;
  width: 414px;
  height: 191px;
  left: 534px;
  top: 520px;
}
#textBox01Text {
  position: relative;
  left: 60px;
  top: 40px;
  font-size: 36px;
  line-height: 49px;
  color: #fbf8f8;
}
#text01 {
  position: absolute;
  font-size: 29px;
  left: 75px;
  top: 440px;
}
#inputField01 {
  position: absolute;
  width: 377px;
  height: 50px;
  left: 80px;
  top: 500px;
}

#tag01 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 71px;
  top: 225px;
}
#tag02 {
  position: absolute;
  width: 300px;
  text-align: center;
  left: 351px;
  top: 225px;
}
#tag03 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 701px;
  top: 225px;
}
#tag04 {
  position: absolute;
  width: 300px;
  text-align: center;
  left: 209px;
  top: 315px;
}
#tag05 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 561px;
  top: 315px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 97.mp4",
        "glo/Video 98.mp4",
        "glo/Video 103.mp4",
        "glo/Video 109a.mp4",
        "glo/Video 104.mp4",
        "glo/Video 105.mp4",
        "glo/Video 106.mp4",
        "glo/Video 107.mp4",
        "glo/Video 108.mp4",
      ]
    }
  }
}
</script>